import { ThemeEnum } from "common/enums/theme";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setTheme } from "store/slices/preferencesSlice";
import styled from "styled-components";
import sun from "assets/icons/sun.svg";
import moon from "assets/icons/moon.svg";
import themeProps from "theme/themes";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Button = styled.button`
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 4px;
  background-color: ${(props: themeProps) => props.theme.themeButton.color};
  border: none;
  cursor: pointer;
`;
const Icon = styled.img`
  width: 100%;
`;

const ThemeSettings = () => {
  const dispatch = useAppDispatch();
  const { theme } = useAppSelector((state) => state.preferences);
  const [isDark, setIsDark] = useState(theme === ThemeEnum.DARK);

  const toggleTheme = () => {
    switch (theme) {
      case ThemeEnum.DARK:
        dispatch(setTheme(ThemeEnum.LIGHT));
        setIsDark(false);
        break;
      case ThemeEnum.LIGHT:
        dispatch(setTheme(ThemeEnum.DARK));
        setIsDark(true);
        break;
    }
  };

  return (
    <Wrapper>
      <Button onClick={toggleTheme}>
        <Icon src={isDark ? sun : moon} />
      </Button>
    </Wrapper>
  );
};

export default ThemeSettings;
